import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Dashboard from "./pages/Dashboard";
import POReconciliation from "./pages/POReconciliation";
import BuyingRepository from "./pages/BuyingRepository";
import Integrations from "./pages/Integrations";
import UAEOutdoorAdvertising from "./pages/UAEOutdoorAdvertising";
import BudgetSimulator from "./pages/BudgetSimulator";
import CreativeAudit from "./pages/CreativeAudit";
import Chatbot from "./pages/Chatbot";
import ChannelDetails from "./pages/ChannelDetails";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="po-reconciliation" element={<POReconciliation />} />
            <Route path="buying-repository" element={<BuyingRepository />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="uae-outdoor" element={<UAEOutdoorAdvertising />} />
            <Route path="budget-simulator" element={<BudgetSimulator />} />
            <Route path="creative-audit" element={<CreativeAudit />} />
            <Route path="chatbot" element={<Chatbot />} />
          </Route>
          <Route path="/channel-details/:channelName" element={<ChannelDetails />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
